import Parse from 'parse'

export default {
  async fetchPlaying ({ commit, dispatch }) {
    const result = await Parse.Cloud.run('userPlayingEvent')
    if (result.status) {
      commit('setStatus', result.status)
    } else {
      commit('setStatus', null)
    }

    if (result.entry) {
      commit('entry/setEntry', result.entry, { root: true })
      commit('setPlaying', result.entry.get('event'))
      dispatch('answer/checkSubmitted', null, { root: true })
      commit('quizset/setQuizset', result.quizset, { root: true })
    }
  }
}
